import router from 'next/router';
import React from 'react';
import { useSelector } from 'react-redux';
import ButtonBase from '@common/Component/Forms/ButtonBase/ButtonBase';
import { ONLINE_PHARMACY_ROUTE, PAYMENT_CURRENCY } from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const PlpBottomCart = () => {
  const generateURL = useNavigationURL();
  const t = useTranslation();

  const reducerItems = useSelector((state) => state?.app?.pdpReducer?.items);
  const [total, setTotal] = React.useState(0);
  const [qty, setQty] = React.useState(0);
  React.useEffect(() => {
    if (reducerItems?.length > 0) {
      const finalTotal = reducerItems?.reduce((tot, item) => Number(tot) + Number(item?.price), 0);
      const finalQty = reducerItems?.reduce((tot, item) => Number(tot) + Number(item?.qty), 0);
      setTotal(Number(finalTotal).toFixed(2));
      setQty(finalQty);
    }
  }, [reducerItems]);

  if (reducerItems?.length > 0) {
    return (
      <div className="fixedPayButton">
        <div className="totalCount">
          <span className="itemCount">{qty} {qty === 1 ? "Item" : t('EPharmacyCheckout.item')}</span>
          <span className="amount">
            {PAYMENT_CURRENCY} {total}
          </span>
        </div>
        <ButtonBase
          variant="success"
          text="Go to Cart"
          onClick={() => router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/mycart`) })}
        />
      </div>
    );
  } else {
    return '';
  }
};

PlpBottomCart.propTypes = {};

export default PlpBottomCart;
